import {TopBar} from "./components/top-bar/TopBar";
import {Outlet} from "react-router-dom";

function App() {
  return (
      <div style={{
          overflowY: 'scroll',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          height: '100%',
      }}>
        <TopBar />
        <div style={{ paddingTop: "100px" }} />
        <Outlet />
      </div>
  );
}

export default App;
